import i18next, { type i18n } from "i18next";
import ICU from "i18next-icu";
import { initReactI18next } from "react-i18next";

import { en } from "./resources/en";

export const appI18n: i18n = i18next.createInstance();

export async function initializeI18n(): Promise<void> {
  if (appI18n.isInitialized) {
    return;
  }

  await appI18n
    .use(ICU)
    .use(initReactI18next)
    .init({
      resources: { en },
      lng: "en",
      fallbackLng: "en",
      supportedLngs: ["en"],
      ns: ["translation", "foundation", "account", "catalog", "designSystem", "errors"],
      defaultNS: "translation",
      interpolation: {
        escapeValue: false,
      },
    });
}
